import { render } from "./editRole.vue?vue&type=template&id=af872568"
import script from "./editRole.vue?vue&type=script&lang=js"
export * from "./editRole.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__